// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"235":"9c41253fb4bec62160b0c69815b15ead","531":"bde7d432713268d9f295a44a9a0209c4","591":"ab12408993417f33e0aaeb59efaee656"}[chunkId] + ".js";
};